import { render, staticRenderFns } from "./addMeeting.vue?vue&type=template&id=0bb6a46a&scoped=true"
import script from "./addMeeting.vue?vue&type=script&lang=js"
export * from "./addMeeting.vue?vue&type=script&lang=js"
import style0 from "./addMeeting.vue?vue&type=style&index=0&id=0bb6a46a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb6a46a",
  null
  
)

export default component.exports